import * as actions from 'apps/website/themes/inline_editor/helpers/actions';
import dispatchMessage from 'apps/website/themes/inline_editor/helpers/dispatchMessage';

type EditorInstance = any;
type ListboxInstance = {
  // eslint-disable-next-line no-unused-vars
  value: (value: string | null) => void;
};
type FormatType = 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type BlockType = { name: string; format: FormatType };
type MenuItemType = {
  text: string;
  value: string | null;
  icon?: string;
  textStyle?: () => string;
  onclick: () => void;
};
type ElementType = {
  parents: ElementType[];
};

const H1_FORMAT = 'h1';
const H2_FORMAT = 'h2';
const H3_FORMAT = 'h3';
const H4_FORMAT = 'h4';
const H5_FORMAT = 'h5';
const H6_FORMAT = 'h6';
const P_FORMAT = 'p';

const HEADER_FORMATS = [H1_FORMAT, H2_FORMAT, H3_FORMAT, H4_FORMAT, H5_FORMAT, H6_FORMAT];

const blocks: BlockType[] = [
  { name: 'Paragraph', format: P_FORMAT },
  { name: 'Heading 1', format: H1_FORMAT },
  { name: 'Heading 2', format: H2_FORMAT },
  { name: 'Heading 3', format: H3_FORMAT },
  { name: 'Heading 4', format: H4_FORMAT },
  { name: 'Heading 5', format: H5_FORMAT },
  { name: 'Heading 6', format: H6_FORMAT },
];

const EDIT_STYLE_GUIDE_VALUE = 'edit-style-guide';

const defaultOption = blocks[0];

export const register = (editor: EditorInstance) => {
  // eslint-disable-next-line
  const handlePostRender = function (this: ListboxInstance) {
    const self = this;

    editor.on('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        HEADER_FORMATS.forEach((tag) => {
          if (editor.formatter.match(tag)) {
            setTimeout(() => {
              editor.execCommand('mceToggleFormat', false, P_FORMAT);
            }, 2);
          }
        });
      }
    });

    editor.on('NodeChange', (element: ElementType) => {
      let value: string | null = null;
      const { formatter } = editor;
      const { parents: elementParents } = element;

      const matchFormat = (node: ElementType) => {
        blocks.forEach((block) => {
          if (!value && formatter.matchNode(node, block.format)) {
            value = block.format;
          }
        });
      };

      elementParents.forEach((node: ElementType) => {
        if (!value) {
          matchFormat(node);
        }
      });

      self.value(value);
    });
  };

  const handleEditStyleGuide = () => {
    dispatchMessage(actions.editStyleGuide());
  };

  const handleSelection = (format: any) => {
    const { control } = format || {};

    if (control && control.value() === EDIT_STYLE_GUIDE_VALUE) {
      // Targets a button inside a menu control to change the menu back to the default option
      control.parent().parent().value(defaultOption.format);
      control.parent().parent().text(defaultOption.name);
    }
  };

  const menuItems: MenuItemType[] = blocks.map((block) => ({
    text: block.name,
    value: block.format,
    onclick: () => editor.execCommand('mceToggleFormat', false, block.format),
  }));

  menuItems.push({
    text: 'Edit style guide',
    icon: 'edit-style-guide',
    value: EDIT_STYLE_GUIDE_VALUE,
    onclick: handleEditStyleGuide,
  });

  editor.addButton('builder_formatselect', {
    type: 'listbox',
    text: defaultOption.name,
    icon: false,
    fixedWidth: true,
    menu: menuItems,
    onPostRender: handlePostRender,
    onselect: handleSelection,
  });
};
